module.exports = __webpack_public_path__ + "static/bonus-pole-dd83817449c8c4ca00cab321d14c6753.jpg";